import Vue from 'vue'
import CalculatorVuex from 'vuex'

Vue.use(CalculatorVuex)

const showCalculadoraDialogSelectTabela = false
const ativarValoresTabelaCBHPM = false
const showDialogShowValores = false
const tabelaPrecoVersao = 'CBHPM2018'

const getters = {
  SHOW_CACULADORA_DIALOG_SELECT_TABELA: (state: any) => state.showCalculadoraDialogSelectTabela,
  SHOW_CACULADORA_DIALOG_SHOW_VALORES: (state: any) => state.showDialogShowValores,
  ATIVAR_VALORES_TABELA_CBHPM: (state: any) => state.ativarValoresTabelaCBHPM,
  TABELA_PRECO_VERSAO: (state: any) => state.tabelaPrecoVersao,
}

const actions = {
  SET_SHOW_CACULADORA_DIALOG_SELECT_TABELA: ({ commit }, show: boolean) => {
    commit('SET_SHOW_CACULADORA_DIALOG_SELECT_TABELA', show)
  },
  SET_SHOW_CACULADORA_DIALOG_SHOW_VALORES: ({ commit }, show: boolean) => {
    commit('SET_SHOW_CACULADORA_DIALOG_SHOW_VALORES', show)
  },
  SET_ATIVAR_VALORES_TABELA_CBHPM: ({ commit }, ativar: boolean) => {
    commit('SET_ATIVAR_VALORES_TABELA_CBHPM', ativar)
  },
  SET_TABELA_PRECO_VERSAO: ({ commit }, table: any) => {
    commit('SET_TABELA_PRECO_VERSAO', table)
  },
}

const mutations = {
  SET_SHOW_CACULADORA_DIALOG_SELECT_TABELA(state: any, show: boolean) {
    state.showCalculadoraDialogSelectTabela = show
  },
  SET_SHOW_CACULADORA_DIALOG_SHOW_VALORES(state: any, show: boolean) {
    state.showDialogShowValores = show
  },
  SET_ATIVAR_VALORES_TABELA_CBHPM(state: any, ativar: Boolean) {
    state.ativarValoresTabelaCBHPM = ativar
  },
  SET_TABELA_PRECO_VERSAO(state: any, table: any) {
    state.tabelaPrecoVersao = table
  },
}

export default new CalculatorVuex.Store({
  state: {
    showCalculadoraDialogSelectTabela,
    showDialogShowValores,
    ativarValoresTabelaCBHPM,
    tabelaPrecoVersao,
  },
  getters,
  actions,
  mutations,
})
